import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: block;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import classNames from "classnames";
const TextBreakWrapper = styled.span.withConfig({
    componentId: "sc-a7c8773c-0"
})(_templateObject());
export const TextBreak = (param)=>{
    let { customClassName  } = param;
    return /*#__PURE__*/ _jsx(TextBreakWrapper, {
        className: classNames("text-break", customClassName)
    });
};
